import { CustomError } from "./data";

export const getCurrentFinancialYear = () => {
    const currentYear = new Date().getFullYear();
    const today = new Date();
    // if current month is less than the 4th month
    if (today.getMonth() < 3) {
        return currentYear - 1;
    } else {
        return currentYear;
    }
}
export const generateYears = () => {
    const currentYear = getCurrentFinancialYear();
    const startYear = 2012;
    let years = [];

    for (let year = startYear; year <= currentYear; year++) {
        years.push({
            prevYear: year,
            nextYear: year + 1
        });
    }

    return years.reverse();
}

export const getRowsClassName = (record, index) => {
    return index % 2 === 0 ? 'zebra-highlight' : '';
}

export const getFormattedTime = (date) => {
    let hours = date.getHours();;
    let minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
    let seconds = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds();

    return `${hours}:${minutes}:${seconds}`;
}

export const getFormattedDate = (date) => {
    const monthDate = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
    const actualMonth = date.getMonth() + 1;
    const month = actualMonth < 10 ? `0${actualMonth}` : actualMonth;
    const year = date.getFullYear();

    return {
        sendDateFormat: `${year}/${month}/${monthDate}`, // send date to backend in this format
        showDateFormat: `${monthDate}/${month}/${year}` // show date to the user in this format
    }
}

export const formatTime = (date) => {
    let hours = date.getHours();
    let minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
    let seconds = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds();


    if (hours > 11) {
        if (hours === 12) {
            return `${hours}:${minutes} PM`;
        }
        if (hours < 20) {
            return `0${hours - 12}:${minutes} PM`
        } else {
            return `${hours}:${minutes} PM`;
        }
    } else {
        if (hours < 10) {
            return `0${hours}:${minutes} AM`;
        } else {
            return `${hours}:${minutes} AM`;
        }
    }

    // if(typeof timeString === 'string') {
    //     let hour = Number(timeString.slice(0, 2));
    //     let minutes = Number(timeString.slice(3, 5));
    //     if(minutes < 10) {
    //         minutes = `0${minutes}`;
    //     }
    //     if(hour > 11) {
    //         if(hour === 12) {
    //             return `${hour}:${minutes} PM`;
    //         }
    //         if(hour < 20) {
    //             return `0${hour - 12}:${minutes} PM`
    //         } else {
    //             return `${hour}:${minutes} PM`;
    //         }
    //     } else {
    //         if(hour < 10) {
    //             return `0${hour}:${minutes} AM`;
    //         } else {
    //             return `${hour}:${minutes} AM`;
    //         }
    //     }
    // } else {
    //     return 'Not a valid time string'
    // }
}

export const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = () => {
            // Extract Base64 string from the result
            const base64String = reader.result.split(',')[1];
            resolve(base64String);
        };

        reader.onerror = () => {
            reject(new Error('Failed to read file'));
        };

        reader.readAsDataURL(file);
    });
}

export function base64ToFile(base64String) {
    // Split the base64 string into data and content type
    const [contentType, base64Data] = base64String.split(',');

    // Decode base64 string to binary data
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    // Create a Blob object from the binary data
    const blob = new Blob([byteArray], { type: contentType });

    // Generate a default file name based on content type if not provided
    const defaultFileName = `file.${contentType.split('/')[1]}`;

    // Create a File object from the Blob
    const file = new File([blob], defaultFileName, { type: contentType });

    return file;
}

// export const fetchWrapper = async(httpVerb = "GET", reqUrl, reqBody, isAuthenticatedReq = true, isBodyJSON = true) => {
//     const allowedRequestVerbs = ["GET", "POST", "PUT", "PATCH", "DELETE", "OPTIONS"];
//     if(reqUrl.trim() === "" || !reqUrl || typeof reqUrl !== "string") {
//         return 'Request URL is not valid';
//     }
//     try {
//         if(allowedRequestVerbs.includes(httpVerb)) {
//             if(httpVerb.toLocaleLowerCase() === "get" || httpVerb.toLocaleLowerCase() === "delete") {
//                 const req = await fetch(reqUrl, {
//                     method: httpVerb,
//                     headers: {
//                         "Authorization": isAuthenticatedReq && `Bearer ${localStorage.getItem("JwtToken")}`
//                     }
//                 });

//                 if(req.status >= 200 && req.status < 300) {
//                     const res = await req.json();
//                     return res;
//                 } else {
//                     throw new CustomError({
//                         code: req.status,
//                         text: req.statusText
//                     })
//                 }
//             }

//             if(httpVerb.toLowerCase() === "put" || 
//               httpVerb.toLowerCase() === "patch" || 
//               httpVerb.toLowerCase() === "post"
//             ) {
//                 if(!reqBody) {
//                     return 'No request body or request body is not valid'
//                 }
//                 const req = await fetch(reqUrl, {
//                     method: httpVerb,
//                     headers: isBodyJSON ? {
//                         "Content-Type": "application/json",
//                         "Authorization": isAuthenticatedReq && `Bearer ${localStorage.getItem("JwtToken")}`,
//                     } : {
//                         "Authorization": isAuthenticatedReq && `Bearer ${localStorage.getItem("JwtToken")}`
//                     },
//                     body: isBodyJSON ? JSON.stringify(reqBody) : reqBody
//                 });

//                 if(req.status >= 200 && req.status < 300) {
//                     const res = await req.json();
//                     return res;
//                 }
//                 if(req.status >= 400 && req.status < 500) {
//                     // console.log('400 error', req.statusText);
//                     throw new CustomError({
//                         code: req.status,
//                         text: req.statusText
//                     })
//                 }

//                 if(req.status >= 500 && req.status < 600) {
//                     // console.log('500 error', req.statusText);
//                     throw new CustomError({
//                         code: req.status,
//                         text: req.statusText
//                     })
//                 }
//             }
//         } else {
//             throw new Error('Given HTTP verb is not allowed');
//         }
//     } catch(err) {
//         return err;
//     }
// }

export const fetchWrapper = async (
    httpVerb = "GET",
    reqUrl,
    reqBody,
    isAuthenticatedReq = true,
    isBodyJSON = true
) => {
    const allowedRequestVerbs = ["GET", "POST", "PUT", "PATCH", "DELETE", "OPTIONS"];

    if (!reqUrl || typeof reqUrl !== "string" || reqUrl.trim() === "") {
        return "Request URL is not valid";
    }

    const token = localStorage.getItem("JwtToken");

    const headers = {};

    if (isAuthenticatedReq && token) {
        headers["Authorization"] = `Bearer ${token}`;
    }

    if (isBodyJSON && ["POST", "PUT", "PATCH"].includes(httpVerb.toUpperCase())) {
        headers["Content-Type"] = "application/json";
    }

    try {
        const options = {
            method: httpVerb,
            headers,
        };

        if (["POST", "PUT", "PATCH"].includes(httpVerb.toUpperCase()) && reqBody) {
            options.body = isBodyJSON ? JSON.stringify(reqBody) : reqBody;
        }

        const req = await fetch(reqUrl, options);

        if (req.status >= 200 && req.status < 300) {
            const res = await req.json();
            return res;
        } else {
            const res = await req.json();
            if (req.status >= 400 && req.status < 500) {
                const message = res?.resMessage || "Error Occurred"
                throw new CustomError({
                    code: req.status,
                    text: req.statusText,
                    message
                })
            }
            throw new CustomError({
                code: req.status,
                text: req.statusText,
            });
        }
    } catch (err) {
        return err;
    }
};


export const generateRandomColor = () => {
    const codes = [1, 2, 3, 4, 5, 6, 7, 8, 9, "a", "b", "c", "d", "e", "f"];
    let colorString = '#';


    for (let i = 0; i < 6; i++) {
        let randomIndex = Math.floor(Math.random() * codes.length);
        colorString += codes[randomIndex];
    }

    return colorString;
}

export function adjustColor(hex, percent) {
    hex = hex.replace(/^#/, '');

    if (hex.length === 3) {
        hex = hex
            .split('')
            .map(char => char + char)
            .join('');
    }

    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    // convert percent to 0–1 range
    const p = percent / 100;

    r = Math.round(r + (255 - r) * p);
    g = Math.round(g + (255 - g) * p);
    b = Math.round(b + (255 - b) * p);

    return (
        '#' +
        [r, g, b]
            .map(v => v.toString(16).padStart(2, '0'))
            .join('')
    );
}

export function getContrastTextColor(hexColor) {
    hexColor = hexColor.replace('#', '');

    // Handle shorthand hex (#fff)
    if (hexColor.length === 3) {
        hexColor = hexColor
            .split('')
            .map(char => char + char)
            .join('');
    }

    const r = parseInt(hexColor.substring(0, 2), 16);
    const g = parseInt(hexColor.substring(2, 4), 16);
    const b = parseInt(hexColor.substring(4, 6), 16);

    // Calculate brightness
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;

    return brightness > 128 ? '#000000' : '#FFFFFF';
}